import { render, staticRenderFns } from "./PublisherPauseModal.vue?vue&type=template&id=b07e6b10"
import script from "./PublisherPauseModal.vue?vue&type=script&lang=js"
export * from "./PublisherPauseModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports